import * as Yup from "yup";

import { isFieldRequiredOrgPreferences } from "contexts/DealOrgPreferencesContext";
import {
  dateSubmitHandler,
  parsePropertyAsSimpleOption,
  parseRecordAsSimpleOption,
  simpleOptionSubmitHandler,
  submitCurrency,
} from "pages/deal/utils/deal_form";
import { LedgerAccount } from "types/api/deal/accounting/ledger_account";
import { Invoice } from "types/api/deal/invoice";
import { OrgPreferencesReadExtended } from "types/api/deal/preferences";
import { Property } from "types/api/deal/property";
import { DealField } from "types/deal";
import { FormObjectMetadata } from "types/formMetadata";

export const PaymentMetadata: FormObjectMetadata = {
  payment_date: {
    fieldName: "payment_date",
    displayName: "Payment Date",
    _schema: Yup.date(),
    initialValue: null,
    submitHandler: dateSubmitHandler,
  },
  reference: {
    fieldName: "reference",
    displayName: "Reference",
    _schema: Yup.string(),
    initialValue: "",
  },
  amount: {
    fieldName: "amount",
    displayName: "Amount",
    initialValue: null,
    _schema: Yup.number().min(0, "Commission must be positive."),
    submitHandler: submitCurrency,
  },
  ledger_account: {
    fieldName: "ledger_account",
    displayName: "Account",
    initialValue: null,
    _schema: Yup.object(),
    submitHandler: simpleOptionSubmitHandler,
    loadHandler: (x) => parseRecordAsSimpleOption<LedgerAccount>(x, "name"),
    submitFieldName: "ledger_account_id",
  },
  invoice: {
    fieldName: "invoice",
    displayName: "Invoice",
    initialValue: null,
    _schema: Yup.object(),
    submitHandler: simpleOptionSubmitHandler,
    loadHandler: (x) => parseRecordAsSimpleOption<Invoice>(x, "invoice_code"),
    submitFieldName: "invoice_id",
  },
};
